export type QueryParams = Record<string, unknown>;

// Drops undefined / null / '' / [] so Strapi and the gateways never see dead filters.
export function stripEmpty(params?: QueryParams | null): QueryParams {
  const out: QueryParams = {};
  if (!params) return out;
  const keys = Object.keys(params);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const value = params[key];
    if (value === undefined || value === null || value === '') continue;
    if (Array.isArray(value) && value.length === 0) continue;
    out[key] = value;
  }
  return out;
}

// Repeat style (`a=1&a=2`) - what Strapi v3 and the gateways expect.
export function serializeParams(params?: QueryParams | null): string {
  const clean = stripEmpty(params);
  const pairs: string[] = [];
  Object.keys(clean).forEach((key) => {
    const values = Array.isArray(clean[key]) ? clean[key] as unknown[] : [clean[key]];
    values.forEach((value) => pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`));
  });
  return pairs.join('&');
}

export function joinUrl(base: string, path: string): string {
  const left = base.replace(/\/+$/, '');
  const right = String(path).replace(/^\/+/, '');
  return right ? `${left}/${right}` : left;
}
